import { ISPGetItemResponse } from '@ms/odsp-datasources/lib/dataSources/item/spListItemRetriever/interfaces/ISPGetItemResponse';
import { isDocLib, isPromotedLinksList, isDocumentLibrary } from '@ms/odsp-datasources/lib/dataSources/listCollection/ListTemplateType';
import { listFacet, listFormUrlsFacet } from '../../dataSource/Facets';
import { IFaceted } from '@ms/items-view/lib/private/models/Facet';
import { buildListMediaTransformFacets } from '../mediaTransform/MediaTransformFacetBuilder';
import { buildMicroServiceFacets } from '../microService/MicroServiceFacetBuilder';
import { ISpPageContext } from '@ms/odsp-datasources/lib/interfaces/ISpPageContext';
import { Killswitch } from '@ms/odsp-utilities/lib/killswitch/Killswitch';

export function buildListFacets(response: ISPGetItemResponse, pageContext: ISpPageContext | undefined): IFaceted {
  return {
    ...buildListFacet(response),
    ...buildListMediaTransformFacets(response),
    ...buildMicroServiceFacets(response, pageContext),
    ...buildListFormUrlsFacet(response)
  };
}

function buildListFacet(response: ISPGetItemResponse): IFaceted {
  const {
    AllowGridMode: allowGridMode,
    DisableGridEditing: disableGridEditing,
    ListTemplateType: listTemplate,
    BasePermissions: {
      ManageLists: allowManageLists = undefined,
      ManagePersonalViews: allowManagePersonalViews = undefined,
      OpenItems: allowOpenItems = undefined,
      UseClientIntegration: useClientIntegration = undefined
    } = {},
    ListSchema: {
      DefaultItemOpen: defaultItemOpen = undefined
    } = {},
    ExcludeFromOfflineClient: excludeFromOfflineClient,
    WebExcludeFromOfflineClient: webExcludeFromOfflineClient,
    ListData: listData,
    listBaseType
  } = response;

  const openInClient = typeof defaultItemOpen === 'string' ? defaultItemOpen === '0' : undefined;
  const newDocLibCheck = !Killswitch.isActivated('7A041F5E-0E2D-4503-9EE7-C45AD45805CA', '12/30/2018', 'Use New IsDocumenLibrary check');

  return listFacet.pack({
    id: response.listName,
    title: response.ListTitle,
    allowGridMode: typeof allowGridMode === 'boolean' ? allowGridMode : true,
    allowCreateFolder: response.AllowCreateFolder,
    disableGridEditing: typeof disableGridEditing === 'boolean' ? disableGridEditing : false,
    enableMinorVersions: response.EnableMinorVersions,
    enableVersions: response.verEnabled,
    templateType: typeof listTemplate === 'string' ? Number(listTemplate) : undefined,
    isDocumentLibrary: typeof listTemplate === 'string' ?
      (newDocLibCheck ? isDocLib(String(listBaseType)) : isDocumentLibrary(listTemplate)) : undefined,
    isPromotedLinks: typeof listTemplate === 'string' ? isPromotedLinksList(listTemplate) : undefined,
    isModerated: response.isModerated,
    newWOPIDocumentEnabled: response.NewWOPIDocumentEnabled,
    newWOPIDocumentTypes: response.NewWOPIDocumentTypes,
    permissions: {
      manageLists: allowManageLists,
      managePersonalViews: allowManagePersonalViews,
      openItems: allowOpenItems,
      useClientIntegration: useClientIntegration
    },
    openInClient: openInClient,
    excludeFromOfflineClient: (typeof excludeFromOfflineClient === 'boolean' || typeof webExcludeFromOfflineClient === 'boolean') ?
      excludeFromOfflineClient || webExcludeFromOfflineClient :
      undefined,
    contentTypesEnabled: response.ContentTypesEnabled,
    metadataNavFeatureEnabled: response.metadataNavFeatureEnabled,
    canUserCreateMicrosoftForm: response.canUserCreateMicrosoftForm,
    itemCount: response.ListSchema && response.ListSchema.ItemCount,
    rowLimit: listData && listData.RowLimit,
    canShareLinkForNewDocument: response.CanShareLinkForNewDocument,
    enableAttachments: response.EnableAttachments === 'true',
    createdFromExcel: response.CreatedFromExcel,
    createdFromExisting: response.CreatedFromExisting
  });
}

function buildListFormUrlsFacet(response: ISPGetItemResponse): IFaceted {
  const {
    displayFormUrl,
    editFormUrl,
    newFormUrl
  } = response;
  return listFormUrlsFacet.pack({
    displayFormUrl,
    editFormUrl,
    newFormUrl
  });
}